import { render, staticRenderFns } from "./tourlist.vue?vue&type=template&id=66b42d55&"
import script from "./tourlist.vue?vue&type=script&lang=js&"
export * from "./tourlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./tourlist.vue?vue&type=custom&index=0&blockType=br"
if (typeof block0 === 'function') block0(component)
import block1 from "./tourlist.vue?vue&type=custom&index=1&blockType=br"
if (typeof block1 === 'function') block1(component)
import block2 from "./tourlist.vue?vue&type=custom&index=2&blockType=br"
if (typeof block2 === 'function') block2(component)
import block3 from "./tourlist.vue?vue&type=custom&index=3&blockType=br"
if (typeof block3 === 'function') block3(component)
import block4 from "./tourlist.vue?vue&type=custom&index=4&blockType=br"
if (typeof block4 === 'function') block4(component)
import block5 from "./tourlist.vue?vue&type=custom&index=5&blockType=br"
if (typeof block5 === 'function') block5(component)
import block6 from "./tourlist.vue?vue&type=custom&index=6&blockType=br"
if (typeof block6 === 'function') block6(component)
import block7 from "./tourlist.vue?vue&type=custom&index=7&blockType=br"
if (typeof block7 === 'function') block7(component)
import block8 from "./tourlist.vue?vue&type=custom&index=8&blockType=br"
if (typeof block8 === 'function') block8(component)
import block9 from "./tourlist.vue?vue&type=custom&index=9&blockType=br"
if (typeof block9 === 'function') block9(component)
import block10 from "./tourlist.vue?vue&type=custom&index=10&blockType=br"
if (typeof block10 === 'function') block10(component)
import block11 from "./tourlist.vue?vue&type=custom&index=11&blockType=br"
if (typeof block11 === 'function') block11(component)
import block12 from "./tourlist.vue?vue&type=custom&index=12&blockType=br"
if (typeof block12 === 'function') block12(component)

export default component.exports